import { Http } from '@angular/http';

import { SETTINGS } from '../../clpbp-app.settings';
import {
  AccountApi,
  AuthenticationApi,
  BankLinkApi,
  BankVerificationApi,
  BorrowerApi,
  BorrowerConfirmationApi,
  BorrowerMortgageLoanApplicationApi,
  BorrowerPersonalLoanApplicationApi,
  BranchOfficeApi,
  ConfigurationApi,
  DashboardApi,
  DocumentsApi,
  EmailApi,
  HmdaApi,
  LeadApi,
  LoanApplicationApi,
  LoanApplicationEventsApi,
  LoanApplicationGeneratedDocumentApi,
  LoanApplicationOfferApi,
  LoanApplicationTaskApi,
  LoanApplicationUploadedDocumentsApi,
  LoanOfficerApi,
  LogApi,
  MortgageBankApi,
  MortgageBorrowerApi,
  MortgageBorrowerEmploymentApi,
  MortgageBorrowerPropertyApi,
  MortgageCreditApi,
  MortgageGovernmentApi,
  MortgageLiabilitiesApi,
  MortgageLoanApplicationApi,
  MortgageLoanApplicationBorrowerApi,
  MortgageLoanOfficerApi,
  MortgageLoanPurposeApi,
  MortgageNotesApi,
  MortgagePricingApi,
  MortgagePurchaseApi,
  MortgageReEntryApi,
  MortgageSalesClosingCostsApi,
  MortgageVALoanEligibilityApi,
  OfferApi,
  PersonalLoanApplicationAgentNoteApi,
  PersonalLoanApplicationBankAccountApi,
  PersonalLoanApplicationBankAccountVerificationApi,
  PersonalLoanApplicationCreditApi,
  PersonalLoanApplicationDisclosureApi,
  PersonalLoanApplicationMessagesApi,
  PersonalLoanApplicationPromoCodeValidationApi,
  PersonalLoanApplicationTouchpointApi,
  PersonalLoanApplicationValidationApi,
  SalesForceApi,
  SBSApi,
  SessionApi,
  TagsApi,
  TaskApi
} from '../../../../generated/internalApi/api/api';
import { Type } from '@angular/core';

export function baseFactory<T>(http: Http, apiType: Type<T>): T {
  const api: any = new apiType(http, SETTINGS.API.URL);
  api.defaultHeaders.set('Content-Type', 'application/json');
  return api;
}

// The factory providers in this file are organized alphabetically.
// Please make an effort to maintain this order.
export const AccountApiFactory = {
  provide: AccountApi,
  useFactory: fAccountApi,
  deps: [Http]
};
export function fAccountApi(http: Http) {
  return baseFactory(http, AccountApi);
}
export const AuthenticationApiFactory = {
  provide: AuthenticationApi,
  useFactory: fAuthenticationApi,
  deps: [Http]
};
export function fAuthenticationApi(http: Http) {
  return baseFactory(http, AuthenticationApi);
}
export const BankVerificationApiFactory = {
  provide: BankVerificationApi,
  useFactory: fBankVerificationApi,
  deps: [Http]
};
export function fBankVerificationApi(http: Http) {
  return baseFactory(http, BankVerificationApi);
}
export const BankLinkApiFactory = {
  provide: BankLinkApi,
  useFactory: fBankLinkApi,
  deps: [Http]
};
export function fBankLinkApi(http: Http) {
  return baseFactory(http, BankLinkApi);
}
export const BorrowerApiFactory = {
  provide: BorrowerApi,
  useFactory: fBorrowerApi,
  deps: [Http]
};
export function fBorrowerApi(http: Http) {
  return baseFactory(http, BorrowerApi);
}
export const BorrowerConfirmationApiFactory = {
  provide: BorrowerConfirmationApi,
  useFactory: BorrowerConfirmationApi,
  deps: [Http]
};
export function fBorrowerConfirmationApi(http: Http) {
  return baseFactory(http, BorrowerConfirmationApi);
}
export const BorrowerMortgageLoanApplicationApiFactory = {
  provide: BorrowerMortgageLoanApplicationApi,
  useFactory: fBorrowerMortgageLoanApplicationApi,
  deps: [Http],
};
export function fBorrowerMortgageLoanApplicationApi(http: Http) {
  return baseFactory(http, BorrowerMortgageLoanApplicationApi);
}
export const BorrowerPersonalLoanApplicationApiFactory = {
  provide: BorrowerPersonalLoanApplicationApi,
  useFactory: fBorrowerPersonalLoanApplicationApi,
  deps: [Http]
};
export function fBorrowerPersonalLoanApplicationApi(http: Http) {
  return baseFactory(http, BorrowerPersonalLoanApplicationApi);
}
export const BranchOfficeApiFactory = {
  provide: BranchOfficeApi,
  useFactory: fBranchOfficeApi,
  deps: [Http]
};
export function fBranchOfficeApi(http: Http) {
  return baseFactory(http, BranchOfficeApi);
}
export const ConfigurationApiFactory = {
  provide: ConfigurationApi,
  useFactory: fConfigurationApi,
  deps: [Http]
};
export function fConfigurationApi(http: Http) {
  return baseFactory(http, ConfigurationApi);
}
export const DashboardApiFactory = {
  provide: DashboardApi,
  useFactory: fDashboardApi,
  deps: [Http]
};
export function fDashboardApi(http: Http) {
  return baseFactory(http, DashboardApi);
}
export const DocumentsApiFactory = {
  provide: DocumentsApi,
  useFactory: fDocumentsApi,
  deps: [Http]
};
export function fDocumentsApi(http: Http) {
  return baseFactory(http, DocumentsApi);
}
export const EmailApiFactory = {
  provide: EmailApi,
  useFactory: fEmailApi,
  deps: [Http]
};
export function fEmailApi(http: Http) {
  return baseFactory(http, EmailApi);
}
export const HmdaApiFactory = {
  provide: HmdaApi,
  useFactory: fHmdaApi,
  deps: [Http]
};
export function fHmdaApi(http: Http) {
  return baseFactory(http, HmdaApi);
}
export const LeadApiFactory = {
  provide: LeadApi,
  useFactory: fLeadApi,
  deps: [Http]
};
export function fLeadApi(http: Http) {
  return baseFactory(http, LeadApi);
}
export const LoanApplicationApiFactory = {
  provide: LoanApplicationApi,
  useFactory: fLoanApplicationApi,
  deps: [Http]
};
export function fLoanApplicationApi(http: Http) {
  return baseFactory(http, LoanApplicationApi);
}
export const LoanApplicationEventsApiFactory = {
  provide: LoanApplicationEventsApi,
  useFactory: fLoanApplicationEventsApi,
  deps: [Http]
};
export function fLoanApplicationEventsApi(http: Http) {
  return baseFactory(http, LoanApplicationEventsApi);
}
export const LoanApplicationGeneratedDocumentApiFactory = {
  provide: LoanApplicationGeneratedDocumentApi,
  useFactory: fLoanApplicationGeneratedDocumentApi,
  deps: [Http]
};
export function fLoanApplicationGeneratedDocumentApi(http: Http) {
  return baseFactory(http, LoanApplicationGeneratedDocumentApi);
}
export const LoanApplicationOfferApiFactory = {
  provide: LoanApplicationOfferApi,
  useFactory: fLoanApplicationOfferApi,
  deps: [Http]
};
export function fLoanApplicationOfferApi(http: Http) {
  return baseFactory(http, LoanApplicationOfferApi);
}
export const LoanApplicationTaskApiFactory = {
  provide: LoanApplicationTaskApi,
  useFactory: fLoanApplicationTaskApi,
  deps: [Http]
};
export function fLoanApplicationTaskApi(http: Http) {
  return baseFactory(http, LoanApplicationTaskApi);
}
export const LoanApplicationUploadedDocumentsApiFactory = {
  provide: LoanApplicationUploadedDocumentsApi,
  useFactory: fLoanApplicationUploadedDocumentsApi,
  deps: [Http]
};
export function fLoanApplicationUploadedDocumentsApi(http: Http) {
  return baseFactory(http, LoanApplicationUploadedDocumentsApi);
}
export const LoanOfficerApiFactory = {
  provide: LoanOfficerApi,
  useFactory: fLoanOfficerApi,
  deps: [Http]
};
export function fLoanOfficerApi(http: Http) {
  return baseFactory(http, LoanOfficerApi);
}
export const LogApiFactory = {
  provide: LogApi,
  useFactory: fLogApi,
  deps: [Http]
};
export function fLogApi(http: Http) {
  return baseFactory(http, LogApi);
}
export const MortgageBankApiFactory = {
  provide: MortgageBankApi,
  useFactory: fMortgageBankApi,
  deps: [Http]
};
export function fMortgageBankApi(http: Http) {
  return baseFactory(http, MortgageBankApi);
}
export const MortgageBorrowerApiFactory = {
  provide: MortgageBorrowerApi,
  useFactory: fMortgageBorrowerApi,
  deps: [Http]
};
export function fMortgageBorrowerApi(http: Http) {
  return baseFactory(http, MortgageBorrowerApi);
}
export const MortgageBorrowerEmploymentApiFactory = {
  provide: MortgageBorrowerEmploymentApi,
  useFactory: fMortgageBorrowerEmploymentApi,
  deps: [Http]
};
export function fMortgageBorrowerEmploymentApi(http: Http) {
  return baseFactory(http, MortgageBorrowerEmploymentApi);
}
export const MortgageBorrowerPropertyApiFactory = {
  provide: MortgageBorrowerPropertyApi,
  useFactory: fMortgageBorrowerPropertyApi,
  deps: [Http]
};
export function fMortgageBorrowerPropertyApi(http: Http) {
  return baseFactory(http, MortgageBorrowerPropertyApi);
}
export const MortgageCreditApiFactory = {
  provide: MortgageCreditApi,
  useFactory: fMortgageCreditApi,
  deps: [Http]
};
export function fMortgageCreditApi(http: Http) {
  return baseFactory(http, MortgageCreditApi);
}
export const MortgageGovernmentApiFactory = {
  provide: MortgageGovernmentApi,
  useFactory: fMortgageGovernmentApi,
  deps: [Http]
};
export function fMortgageGovernmentApi(http: Http) {
  return baseFactory(http, MortgageGovernmentApi);
}
export const MortgageLiabilitiesApiFactory = {
  provide: MortgageLiabilitiesApi,
  useFactory: fMortgageLiabilitiesApi,
  deps: [Http]
};
export function fMortgageLiabilitiesApi(http: Http) {
  return baseFactory(http, MortgageLiabilitiesApi);
}
export const MortgageLoanApplicationApiFactory = {
  provide: MortgageLoanApplicationApi,
  useFactory: fMortgageLoanApplicationApi,
  deps: [Http]
};
export function fMortgageLoanApplicationApi(http: Http) {
  return baseFactory(http, MortgageLoanApplicationApi);
}
export const MortgageLoanApplicationBorrowerApiFactory = {
  provide: MortgageLoanApplicationBorrowerApi,
  useFactory: fMortgageLoanApplicationBorrowerApi,
  deps: [Http]
};
export function fMortgageLoanApplicationBorrowerApi(http: Http) {
  return baseFactory(http, MortgageLoanApplicationBorrowerApi);
}
export const MortgageLoanOfficerApiFactory = {
  provide: MortgageLoanOfficerApi,
  useFactory: fMortgageLoanOfficerApi,
  deps: [Http]
};
export function fMortgageLoanOfficerApi(http: Http) {
  return baseFactory(http, MortgageLoanOfficerApi);
}
export const MortgagePricingFactory = {
  provide: MortgagePricingApi,
  useFactory: fMortgagePricingApi,
  deps: [Http]
};
export function fMortgagePricingApi(http: Http) {
  return baseFactory(http, MortgagePricingApi);
}
export const MortgageLoanPurposeFactory = {
  provide: MortgageLoanPurposeApi,
  useFactory: fMortgageLoanPurposeApi,
  deps: [Http]
};
export function fMortgageLoanPurposeApi(http: Http) {
  return baseFactory(http, MortgageLoanPurposeApi);
}
export const MortgageNotesApiFactory = {
  provide: MortgageNotesApi,
  useFactory: fMortgageNotesApi,
  deps: [Http]
};
export function fMortgageNotesApi(http: Http) {
  return baseFactory(http, MortgageNotesApi);
}
export const MortgagePurchaseApiFactory = {
  provide: MortgagePurchaseApi,
  useFactory: fMortgagePurchaseApi,
  deps: [Http]
};
export function fMortgagePurchaseApi(http: Http) {
  return baseFactory(http, MortgagePurchaseApi);
}
export const MortgageReEntryApiFactory = {
  provide: MortgageReEntryApi,
  useFactory: fMortgageReEntryApi,
  deps: [Http]
};
export function fMortgageReEntryApi(http: Http) {
  return baseFactory(http, MortgageReEntryApi);
}
export const MortgageSalesClosingCostsApiFactory = {
  provide: MortgageSalesClosingCostsApi,
  useFactory: fMortgageSalesClosingCostsApi,
  deps: [Http]
};
export function fMortgageSalesClosingCostsApi(http: Http) {
  return baseFactory(http, MortgageSalesClosingCostsApi);
}
export const MortgageVALoanEligibilityApiFactory = {
  provide: MortgageVALoanEligibilityApi,
  useFactory: fMortgageVALoanEligibilityApi,
  deps: [Http]
};
export function fMortgageVALoanEligibilityApi(http: Http) {
  return baseFactory(http, MortgageVALoanEligibilityApi);
}
export const OfferApiFactory = {
  provide: OfferApi,
  useFactory: fOfferApi,
  deps: [Http]
};
export function fOfferApi(http: Http) {
  return baseFactory(http, OfferApi);
}
export const PersonalLoanApplicationAgentNoteApiFactory = {
  provide: PersonalLoanApplicationAgentNoteApi,
  useFactory: fPersonalLoanApplicationAgentNoteApi,
  deps: [Http]
};
export function fPersonalLoanApplicationAgentNoteApi(http: Http) {
  return baseFactory(http, PersonalLoanApplicationAgentNoteApi);
}
export const PersonalLoanApplicationBankAccountApiFactory = {
  provide: PersonalLoanApplicationBankAccountApi,
  useFactory: fPersonalLoanApplicationBankAccountApi,
  deps: [Http]
};
export function fPersonalLoanApplicationBankAccountApi(http: Http) {
  return baseFactory(http, PersonalLoanApplicationBankAccountApi);
}
export const PersonalLoanApplicationBankAccountVerificationApiFactory = {
  provide: PersonalLoanApplicationBankAccountVerificationApi,
  useFactory: fPersonalLoanApplicationBankAccountVerificationApi,
  deps: [Http]
};
export function fPersonalLoanApplicationBankAccountVerificationApi(http: Http) {
  return baseFactory(http, PersonalLoanApplicationBankAccountVerificationApi);
}
export const PersonalLoanApplicationCreditApiFactory = {
  provide: PersonalLoanApplicationCreditApi,
  useFactory: fPersonalLoanApplicationCreditApi,
  deps: [Http]
};
export function fPersonalLoanApplicationCreditApi(http: Http) {
  return baseFactory(http, PersonalLoanApplicationCreditApi);
}
export const PersonalLoanApplicationDisclosureApiFactory = {
  provide: PersonalLoanApplicationDisclosureApi,
  useFactory: fPersonalLoanApplicationDisclosureApi,
  deps: [Http]
};
export function fPersonalLoanApplicationDisclosureApi(http: Http) {
  return baseFactory(http, PersonalLoanApplicationDisclosureApi);
}
export const PersonalLoanApplicationMessagesApiFactory = {
  provide: PersonalLoanApplicationMessagesApi,
  useFactory: fPersonalLoanApplicationMessagesApi,
  deps: [Http]
};
export function fPersonalLoanApplicationMessagesApi(http: Http) {
  return baseFactory(http, PersonalLoanApplicationMessagesApi);
}
export const PersonalLoanApplicationPromoCodeValidationApiFactory = {
  provide: PersonalLoanApplicationPromoCodeValidationApi,
  useFactory: fPersonalLoanApplicationPromoCodeValidationApi,
  deps: [Http]
};
export function fPersonalLoanApplicationPromoCodeValidationApi(http: Http) {
  return baseFactory(http, PersonalLoanApplicationPromoCodeValidationApi);
}
export const PersonalLoanApplicationTouchpointApiFactory = {
  provide: PersonalLoanApplicationTouchpointApi,
  useFactory: fPersonalLoanApplicationTouchpointApi,
  deps: [Http]
};
export function fPersonalLoanApplicationTouchpointApi(http: Http) {
  return baseFactory(http, PersonalLoanApplicationTouchpointApi);
}
export const PersonalLoanApplicationValidationApiFactory = {
  provide: PersonalLoanApplicationValidationApi,
  useFactory: fPersonalLoanApplicationValidationApi,
  deps: [Http]
};
export function fPersonalLoanApplicationValidationApi(http: Http) {
  return baseFactory(http, PersonalLoanApplicationValidationApi);
}
export const SalesForceApiFactory = {
  provide: SalesForceApi,
  useFactory: fSalesForceApi,
  deps: [Http]
};
export function fSalesForceApi(http: Http) {
  return baseFactory(http, SalesForceApi);
}
export const SBSApiFactory = {
  provide: SBSApi,
  useFactory: fSBSApi,
  deps: [Http]
};
export function fSBSApi(http: Http) {
  return baseFactory(http, SBSApi);
}
export const SessionApiFactory = {
  provide: SessionApi,
  useFactory: fSessionApi,
  deps: [Http]
};
export function fSessionApi(http: Http) {
  return baseFactory(http, SessionApi);
}
export const TagsApiFactory = {
  provide: TagsApi,
  useFactory: fTagsApi,
  deps: [Http]
};
export function fTagsApi(http: Http) {
  return baseFactory(http, TagsApi);
}
export const TaskApiFactory = {
  provide: TaskApi,
  useFactory: fTaskApi,
  deps: [Http]
};
export function fTaskApi(http: Http) {
  return baseFactory(http, TaskApi);
}

export const ApiFactories = [
  AccountApiFactory,
  AuthenticationApiFactory,
  BankLinkApiFactory,
  BankVerificationApiFactory,
  BorrowerApiFactory,
  BorrowerConfirmationApiFactory,
  BorrowerMortgageLoanApplicationApiFactory,
  BorrowerPersonalLoanApplicationApiFactory,
  BranchOfficeApiFactory,
  ConfigurationApiFactory,
  DashboardApiFactory,
  DocumentsApiFactory,
  EmailApiFactory,
  HmdaApiFactory,
  LeadApiFactory,
  LoanApplicationApiFactory,
  LoanApplicationEventsApiFactory,
  LoanApplicationGeneratedDocumentApiFactory,
  LoanApplicationOfferApiFactory,
  LoanApplicationTaskApiFactory,
  LoanApplicationUploadedDocumentsApiFactory,
  LoanOfficerApiFactory,
  LogApiFactory,
  MortgageBankApiFactory,
  MortgageBorrowerApiFactory,
  MortgageBorrowerEmploymentApiFactory,
  MortgageBorrowerPropertyApiFactory,
  MortgageCreditApiFactory,
  MortgageGovernmentApiFactory,
  MortgageLiabilitiesApiFactory,
  MortgageLoanApplicationApiFactory,
  MortgageLoanApplicationBorrowerApiFactory,
  MortgageLoanOfficerApiFactory,
  MortgageNotesApiFactory,
  MortgagePricingFactory,
  MortgageLoanPurposeFactory,
  MortgagePurchaseApiFactory,
  MortgageReEntryApiFactory,
  MortgageSalesClosingCostsApiFactory,
  MortgageVALoanEligibilityApiFactory,
  OfferApiFactory,
  PersonalLoanApplicationAgentNoteApiFactory,
  PersonalLoanApplicationBankAccountApiFactory,
  PersonalLoanApplicationBankAccountVerificationApiFactory,
  PersonalLoanApplicationCreditApiFactory,
  PersonalLoanApplicationDisclosureApiFactory,
  PersonalLoanApplicationMessagesApiFactory,
  PersonalLoanApplicationPromoCodeValidationApiFactory,
  PersonalLoanApplicationTouchpointApiFactory,
  PersonalLoanApplicationValidationApiFactory,
  SalesForceApiFactory,
  SBSApiFactory,
  SessionApiFactory,
  TagsApiFactory,
  TaskApiFactory
];
